// extracted by mini-css-extract-plugin
export default {"container":"Transcript_container__qd6ep","header":"Transcript_header__L7QnP","dialogue":"Transcript_dialogue__xk1WW"};